// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "8ead723f-dirty",
    "hash": "8ead723f",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "8ead723f-dirty",
    "semverString": null,
    "version": "1.4.0",
    "fullVersion": "1.4.0-8ead723f-dirty"
};
/* tslint:enable */
